/**
 * Backend API client. Uses REACT_APP_API_URL (default http://localhost:3001).
 * All accelerator/investor scraping and extraction go through the backend (no OpenAI from UI).
 * Special-accounts check also goes through backend.
 */

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001';

async function get(path) {
  const res = await fetch(`${BASE}${path}`);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || res.statusText || 'Request failed');
  return data;
}

async function post(path, body) {
  const res = await fetch(`${BASE}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || res.statusText || 'Request failed');
  return data;
}

// --- Accelerator ---
export async function scrapeAcceleratorWebsite(websiteUrl) {
  return post('/api/accelerator/scrape', { websiteUrl });
}

export async function extractAcceleratorInfoFromWebsite(scrapedData) {
  return post('/api/accelerator/extract-website', scrapedData);
}

export async function extractAcceleratorInfoFromText(acceleratorText) {
  return post('/api/accelerator/extract-text', { acceleratorText });
}

export async function scrapeAndExtractAcceleratorInfo(websiteUrl) {
  return post('/api/accelerator/scrape-and-extract', { websiteUrl });
}

// --- Investor ---
export async function scrapeInvestorWebsite(websiteUrl) {
  return post('/api/investor/scrape', { websiteUrl });
}

export async function extractInvestorInfoFromWebsite(scrapedData) {
  return post('/api/investor/extract-website', scrapedData);
}

export async function extractInvestorInfoFromText(investorText) {
  return post('/api/investor/extract-text', { investorText });
}

export async function scrapeAndExtractInvestorInfo(websiteUrl) {
  return post('/api/investor/scrape-and-extract', { websiteUrl });
}

// --- Special accounts ---
export async function isSpecialAccount(userId) {
  if (!userId) return false;
  try {
    const { special } = await get(`/api/special-accounts/check?userId=${encodeURIComponent(userId)}`);
    return !!special;
  } catch {
    return false;
  }
}
